import moment from 'moment-timezone';
import {
  DATE_TIMEFORMAT, TIMEZONE_EST, TIMEZONE_CST, TIMEZONE_PST,
} from './constants';

const currentTimeParserWithTimezone = (timezone) => {
  let currentDateTime = '';

  if (timezone === TIMEZONE_EST) {
    moment.tz.setDefault('America/New_York');
    const nowEST = moment();
    currentDateTime = nowEST.format(DATE_TIMEFORMAT);
  } else if (timezone === TIMEZONE_CST) {
    moment.tz.setDefault('America/Chicago');
    const nowCST = moment();
    currentDateTime = nowCST.format(DATE_TIMEFORMAT);
  } else if (timezone === TIMEZONE_PST) {
    moment.tz.setDefault('America/Los_Angeles');
    const nowPST = moment();
    currentDateTime = nowPST.format(DATE_TIMEFORMAT);
  }
  const parseCurrentDateTime = moment(currentDateTime, DATE_TIMEFORMAT);
  return parseCurrentDateTime;
};

export default currentTimeParserWithTimezone;
